import type { IncentiveSettlement } from '@integration/offerstore-api-models';

import type {
  ConsumptionPrice,
  EnergyType,
  Incentive,
  ProductDuration,
} from './core-modules';

export interface OffersRequestParams {
  flowId: string;
  campaignId: string;
  duration: ProductDuration;
  incentiveId?: string;
  highlightId?: string;
}

export interface AoMOfferRequestParams {
  flowId: string;
  campaignId: string;
  incentiveId?: string;
  durationInYears: ProductDuration;
}

export interface AomOfferResponse {
  meta_data: {
    flow_id: string;
  };
  payload: {
    campaign: AomCampain;
    offer_overviews: AomOfferOverview[];
    vat_included: boolean;
    total_amounts: AomTotalPrice;
    incentive?: AomIncentive;
    budget_bill: AoMBudgetBill;
    disclaimer_url?: string;
  }[];
}

export interface AomCampain {
  id: string;
  name: string;
  description: string;
}

export interface AomOfferOverview {
  product: AomProduct;
  financial_incentives: Incentive[];
  consumption_prices?: ConsumptionPrice[];
  price_groups: AomPriceGroup[];
  total_price: AomTotalPrice;
}

export interface AomIncentive {
  id: string;
  description: string;
  discount_price?: number;
  distribution_plan: string;
  settlements?: IncentiveSettlement[];
}

export interface AomProduct {
  duration_in_years: number;
  energy_type: EnergyType;
  proposition_id: string;
  proposition_description: string;
  contract_type: ContractType;
}

export enum ContractType {
  FIXED = 'fixed',
  DYNAMIC = 'dynamic',
  VARIABLE = 'variable',
}

export interface AomPriceGroup {
  id: string;
  description: string;
  prices: AomPrice[];
  total_price: AomTotalPrice;
}

export interface AomPrice {
  id: string;
  description: string;
  unit: string;
  unit_price: number;
  expected_period_amount: number;
  from_date: string;
  to_date: string;
}

export interface AomTotalPrice {
  expected_yearly_amount: number;
  expected_monthly_amount: number;
}

export interface AoMBudgetBill {
  amount: number;
  limits?: AoMBudgetBillLimits;
}

export interface AoMBudgetBillLimits {
  min_amount: number;
  max_amount: number;
}
